<template>
<DialogBox title="Edit Details" :settings="settings" @save="saveRecord" @show="show">

<v-menu slot="header" offset-y>
    <template v-slot:activator="{ on }">
    <v-icon v-on="on">more_vert</v-icon>
    </template>
    <v-list>
        <v-list-item v-for="menu in menus" @click="menuClicked(menu)" :key="menu.name">
            <v-list-item-title>{{menu.title}}</v-list-item-title>
        </v-list-item>
    </v-list>
</v-menu>

<div class="pa-3">
    <InterfaceField v-for="(field, index) in fields" :field="field" :record="record" :settings="{editing:false}" :element=field :key="index" />
</div>
<DeleteButton v-if="settings.deleteButton" slot="footer" @delete="deleteButtonClicked"/>
</DialogBox>
</template>

<script>
import DataHelpers from '../helpers/DataHelpers'
import DialogBox from '../ui-elements/DialogBox'
import InterfaceField from '../builder/InterfaceField'
import DeleteButton from '../ui-elements/DeleteButton'

export default {
    data() {
        return {
        
        }
    },

    components: {
        DialogBox, InterfaceField, DeleteButton
    },
    
    props: {
        settings: Object,
        fields: Array,
        record: Object,
    },

    computed: {
        menus() {
            return this.fields.filter(o => o.type == 'Menu')
        }
    },

    methods: {
        saveRecord() {
            this.$emit('save', this.record)
        },

        deleteButtonClicked() {
            this.$emit('delete', this.record)
        },

        menuClicked(menu) {
            let record = this.record
            this.$emit('menu', {menu, record} )
        },

        show() {
            
        }
    },

    created() {
        
    }
}
</script>

<style scoped>
   
</style>




// WEBPACK FOOTER //
// AdvancedDialog.vue?0a82c753